/**
 * PersonFunction actions.
 * @module actions/personfunction/personfunction
 */

import {
  GET_PERSONFUNCTIONS,
  SET_PERSONFUNCTION,
} from '../../constants/ActionTypes';

/**
 * Get information of assignd persons and their function
 * @function getPersonFunctions
 * @returns {Object} personfunction action.
 */
export function getPersonFunctions(url, subrequest) {
  return {
    type: GET_PERSONFUNCTIONS,
    subrequest,
    request: {
      op: 'get',
      path: `${url}/@personfunction`,
    },
  };
}

/**
 * Set a persons function.
 * @function setPersonFunction
 * @param {Object} person and function data.
 * @returns {Object} personfunction action.
 */
export function setPersonFunction(url, personId, func, subrequest) {
  if (personId) {
    return {
      type: SET_PERSONFUNCTION,
      subrequest,
      request: {
        op: 'post',
        path: `${url}/@personfunction`,
        data: { person: personId, function: func || '' },
      },
    };
  }
}
